<template>
  <div class="row">
    <div class="col titre">
      <h2>Endroit</h2>
    </div>
  </div>
  <CriteresRechercheEndroit @rechercher="rechercher" :isRechercheDataLoading="isRechercheDataLoading"/>
  <ResultatRechercheEndroit :endroits="endroits" :isRechercheDataLoading="isRechercheDataLoading" @removeEndroitFromList="removeEndroitFromList"/>
</template>

<script>
import CriteresRechercheEndroit from '../../../../components/pilotage/Fichiers/Endroit/CriteresRechercheEndroit.vue'
import ResultatRechercheEndroit from '../../../../components/pilotage/Fichiers/Endroit/ResultatRechercheEndroit.vue'

export default { 
  components: {
    CriteresRechercheEndroit,
    ResultatRechercheEndroit
  },
  mounted() {
    this.$root.$refs.breadcrumbComp.ajout("Recherche Endroit");
  },
  data() {
    return {
      endroits: [],
      isRechercheDataLoading: false,
    }
  },
  methods: {
    rechercher(criteresRecherche) {
      this.isRechercheDataLoading = true;
      this.$store.dispatch('pilotage/rechercherEndroitAction', criteresRecherche)
      .then((res) => {
        this.isRechercheDataLoading = false;
        this.endroits = res.data;
      });
    },
    removeEndroitFromList(cle) {
      this.endroits = this.endroits.filter(current => (current.cle != cle))
    }
  }
}

</script>
